module.exports = __webpack_public_path__ + "img/hero.37de4d46.webp";